import { FC } from "react"

import { ISearchbarFormState } from "components/form/searchbarForm/SearchbarForm.types"
import SearchbarFormWithButtons from "components/form/searchbarFormWithButtons"
import PopoverSearchbarButton from "components/module/classStudentsTeacher/common/viewCommonElementsContainer/popoverSearchbarButton"
import { usePopover } from "hooks/popover"
import { useTranslation } from "react-i18next"
import { TransactionTypeShort } from "ts/types/Transaction"

import { getSetupClassTranslation } from "../../SetupClassTeacher.utils"

interface IProps {
  variant: TransactionTypeShort
  onAddItemClick: () => void
  onAddSuggestedClick: () => void
  onSearchFormSubmit: (data: ISearchbarFormState) => void
}

const SearchbarAndAddButton: FC<IProps> = ({
  variant,
  onAddItemClick,
  onAddSuggestedClick,
  onSearchFormSubmit,
}) => {
  const { t } = useTranslation()
  const tKey = getSetupClassTranslation(variant)
  const { popoverAnchorEl, handleClick, handleClose } =
    usePopover<HTMLButtonElement>()
  const open = Boolean(popoverAnchorEl)

  return (
    <>
      <SearchbarFormWithButtons
        searchbarFormProps={{
          placeholder: t(tKey.searchForItem),
          onSubmit: onSearchFormSubmit,
        }}
        buttonTitle={t(tKey.addItem)}
        onButtonClick={(e) => {
          if (e) handleClick(e as React.MouseEvent<HTMLButtonElement>)
        }}
        buttonAriaHasPopup
        buttonAriaExpanded={open}
      />
      <PopoverSearchbarButton
        open={open}
        anchorEl={popoverAnchorEl}
        onClose={handleClose}
        items={[
          {
            name: t(tKey.addItem),
            onClick: () => {
              handleClose()
              onAddItemClick()
            },
          },
          {
            name: t(tKey.addSuggestedItems),
            onClick: () => {
              handleClose()
              onAddSuggestedClick()
            },
          },
        ]}
      />
    </>
  )
}

export default SearchbarAndAddButton
